// extracted by mini-css-extract-plugin
export var centerAligned = "MDzsY8fVXhERB1dQLoL_";
export var info = "XneWtUjl283qa1YKdPzN";
export var leftBorder = "ZMrzUUCIQjJEBchMDexO";
export var negative = "ZsaVTAG82_piSiGEPxL9";
export var neutral = "XeR0Wy04XSh9S2wWtOlu";
export var positive = "Lc4Oc7eWijtNbt5xJRrb";
export var primary = "B79Ql9b1wTd6X8zJnflh";
export var root = "vWOyw0cqefrBwkmGSD0Q";
export var secondary = "gD5abPFf5yKXTPcdpNoB";
export var title = "ANVmKK7FLvYwjG8rSwuq";
export var warning = "s75EgnSBV2P6TU7GnKsI";
export var withChevron = "ffDA1A4qoAWj8EcTENI7";